<template>
  <div class="flex flex-wrap py-0">
    <div v-for="(item, index) in filteredItems" :key="index">
      <slot name="element" :index="index" :item="item" />
    </div>
    <div class="flex flex-wrap">
      <div v-if="shouldBreak">
        <slot name="toggle" :toggleShow="toggleShowAll" :show="showAll" />
      </div>
      <div>
        <slot name="after" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, toRefs } from "vue";

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  hideBreakpoint: {
    type: Number,
    default: () => 3,
  },
});

const showAll = ref(false);
const toggleShowAll = () => {
  showAll.value = !showAll.value;
};

const { items, hideBreakpoint } = toRefs(props);

const shouldBreak = computed(() => hideBreakpoint.value < items.value?.length);

const filteredItems = computed(() =>
  showAll.value ? items.value : items.value?.slice(0, hideBreakpoint?.value)
);
</script>
